/**
 * User: mphee
 * Date: 1/4/13
 * Time: 12:39 PM
 */

if (!window.console) window.console = {};
if (!window.console.log) window.console.log = function () {};

/*
 * Common Config object.
 */

window.commonConfig = {
    setup: function () {
        // Create a global jQuery instance
        window.$ = $;

        this._setupOeAppData();
        this._setupAjax();
        this._setupExtensions();
        this._setupNls();
        this._setupI18nShim();
        this._setupMobile();
        this._setupGoogleTagManager();
        this._postTasks();

        // todo: need method to update the head with common items like favicon and meta data.
    },

    _postTasks: function () {
        var _this = this;
        $(document).ready(function(){
            _this.replaceRecursive(document.getElementsByTagName('html')[0], window.navigator.userLanguage || window.navigator.language, _this.getNLS().split('-')[0].toLowerCase()); })
    },

    replaceRecursive: function(element, browserlang, appLang) {
        if (element && element.style && this.getStyle(element, 'text-transform') == 'uppercase') {
            if (element.value) {
                if (browserlang == 'tr') {
                    if (browserlang == appLang) {
                        element.value = element.value.replace(/&#x131;/g, 'I');
                        element.value = element.value.replace(/i/g, "\u0130");
                    } else {
                        element.value = element.value.replace(/i/g, "I");
                    }
                }
            }
            for (var i = 0; i < element.childNodes.length; ++i) {
                if (element.childNodes[i].nodeType == Node.TEXT_NODE) {
                    if (browserlang == 'tr') {
                        if (browserlang==appLang) {
                            element.childNodes[i].textContent = element.childNodes[i].textContent.replace(/&#x131;/g, 'I');
                            element.childNodes[i].textContent = element.childNodes[i].textContent.replace(/i/g, "\u0130");
                        } else {
                            element.childNodes[i].textContent = element.childNodes[i].textContent.replace(/i/g, "I");
                        }
                    }
                } else {
                    this.replaceRecursive(element.childNodes[i], browserlang,appLang);
                }
            }
        } else {
            if (!element.childNodes || element.childNodes.length == 0) return;

            for (var i = 0; i < element.childNodes.length; ++i) {
                this.replaceRecursive(element.childNodes[i], browserlang,appLang);
            }
        }
    },

    getStyle: function(element, style) {
        var result;

        if (document.defaultView && document.defaultView.getComputedStyle) {
            result = document.defaultView.getComputedStyle(element, '').getPropertyValue(style);
        } else if(element.currentStyle) {
            style = style.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            result = element.currentStyle[style];
        }
        return result;
    },

    _setupOeAppData: function() {
        if (!window.oeApp.hasData('common')) {
            window.oeApp.addData({'common': {}});
        }

        var common = window.oeApp.getData('common');

        if (!common.oeUserAgent) {
            common.oeUserAgent = this._getCookie('oe-user-agent');
        }
    },

    _setupAjax: function () {
        $.ajaxSetup({
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            statusCode: {
                401: function () {
                    window.location = window.oeApp.getData('common').loginUrl;
                }
            }
        });
    },

    /** mainly for IE **/
    _setupExtensions: function () {
        if (typeof String.prototype.trimLeft !== "function") {
            String.prototype.trimLeft = function () {
                return this.replace(/^\s+/, "");
            };
        }
        if (typeof String.prototype.trimRight !== "function") {
            String.prototype.trimRight = function () {
                return this.replace(/\s+$/, "");
            };
        }
        if (typeof Array.prototype.map !== "function") {
            Array.prototype.map = function (callback, thisArg) {
                for (var i = 0, n = this.length, a = []; i < n; i++) {
                    if (i in this) a[i] = callback.call(thisArg, this[i]);
                }
                return a;
            };
        }
    },

    showNlsConsole: function () {
        return (this._getCookie('consoles') === 'nlsConsole');
    },

    /*
     * Setup for mobile use.
     */
    _setupMobile: function () {
        var $body = $('body');

        if (window.oeApp.isMobileDevice()) {
            $body.addClass('mobile');
        }

        if (window.oeApp.isTouchDevice()) {
            $body.addClass('touch');
        }

        if (window.oeApp.isAndroidDevice()) {
            $body.addClass('android');
        }
    },

    _setupNls: function () {
        // Setup the NLS console.
        if (this.showNlsConsole()) {
            require(['admin/views/NlsConsole'], function (NlsConsole) {
                new NlsConsole({el: $('body')});
            });
        }

        // Add NLS value to body.
        $('body').addClass('lang-' + this.getNLSLanguage());
    },

    _setupI18nShim: function () {
        var lang = this.getNLSLanguage();
        $.ajax({
            url: '/js/nls/' + lang + '/messages',
            async: false,
            dataType: 'text',
            success: function (data) {
                var translationsJSONString = /define\((.*?)\);/.exec(data)[1];
                window.i18n = JSON.parse(translationsJSONString);
            }
        });

        var _getTranslation = function(propertyNames, data, defaultValue) {
            var text = _.get(window.i18n, propertyNames, defaultValue);
            if (data) {
                text = _.template(text)(data);
            }
            return text;
        }

        window.i18n.get = function(propertyNames, data) {
            return _getTranslation(propertyNames, data);
        };
        window.i18n.getDefault = function(propertyNames, defaultValue, data) {
            return _getTranslation(propertyNames, data, defaultValue);   
        };
    },

    _getCookie: function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    _setCookie: function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },

    getNLS: function () {
        return (this._getCookie("NLS") || 'en');
    },

    getLiveAgentNLS: function () {
        var nls = this._getCookie("NLS");
        if (!nls || nls == 'en'){
            return 'es';
        }
        return nls;
    },


    // Return just the language portion of the NLS value (i.e. don't include the country specific portion).
    getNLSLanguage: function () {
        var nls = this.getNLS().split('-')[0].toLowerCase();
        if (!this.isSupportedLanguage(nls)) {
            return 'en';
        }

        return nls;
    },

    setNLS: function (newNLS) {
        if (newNLS) newNLS = newNLS.toLowerCase();
        this._setCookie("NLS", newNLS, 30);
        return true;
    },

    getParameterByName: function (name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null) {
            return "";
        }
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    },

    playDictAudio: function (count) {
        var audio = document.getElementsByTagName("audio")[count];
        audio.load();
        audio.play();
    },

    _setupGoogleTagManager: function() {
        window.oeApp.setupGoogleTagManager();
    },

    isSupportedLanguage: function(nls) {
        return nls.match('en|es|pt') != null;
    }

};

if ('1' === commonConfig.getParameterByName('nlsConsole')) {
    commonConfig._setCookie('consoles', 'nlsConsole');
} else if ('0' === commonConfig.getParameterByName('nlsConsole')) {
    commonConfig._setCookie('consoles', '');
}

window.oeApp = {
    data: {},
    clientStartTime: new Date(),
    nlsData: [],

    addData: function (data) {
        $.extend(this.data, data);
    },

    addNlsData: function (data) {
        var index = this.nlsData.length;

        this.nlsData[index] = data;

        return index;
    },

    getData: function (key) {
        return (typeof(this.data[key]) !== 'undefined' ? this.data[key] : {});
    },

    getCurrentTime: function () {
        if (this.hasData('common')) {
            var commonData = this.getData('common'),
                currentClientTime = new Date().getTime();

            return (commonData.serverTime + currentClientTime - this.clientStartTime);
        } else if (this.hasData('serverTime')) {
            var serverTime = this.getData('serverTime'),
                currentClientTime = new Date().getTime();

            return (serverTime + currentClientTime - this.clientStartTime);
        } else {
            return null;
        }
    },

    getNlsData: function (index) {
        if (index != null) {
            return this.nlsData[index];
        } else {
            return {};
        }
    },

    getServerTimezone: function() {
        if (this.hasData('common') && this.getData('common').uiTimezone) {
            return window.oeApp.getData('common').uiTimezone;
        } else {
            return 'America/New_York';
        }
    },

    getTimezone: function() {
        if (this.hasData('person') && this.getData('person').timezone) {
            return this.getData('person').timezone;
        } else {
            return this.getServerTimezone();
        }
    },

    hasData: function (key) {
        return (this.data[key] ? true : false);
    },

    isAndroidDevice: function() {
        var ua = navigator.userAgent.toLowerCase(),
            isAndroid = ua.indexOf("android") > -1;

        return isAndroid;
    },

    isIphoneOrIpadDevice: function() {
        var ua = navigator.userAgent.toLowerCase(),
            isIphone = ua.indexOf("iphone") > -1,
            isIpad = ua.indexOf("ipad") > -1;

        return (isIphone || isIpad);
    },

    isLoggedIn: function() {
        return this.hasData('person');
    },

    isMobileDevice: function() {
        return this.isAndroidDevice() || this.isIphoneOrIpadDevice();
    },

    isNotMobileDevice: function() {
        return !this.isMobileDevice();
    },

    isNotProduction: function () {
        return !this.isProduction();
    },

    isOpenEnglishDevice: function() {
        var oeUserAgent = (this.getData('common').oeUserAgent ? this.getData('common').oeUserAgent : '');

        return (oeUserAgent.indexOf('LP2') == 0);
    },

    isProduction: function () {
        return ('PRD' === this.getData('common').env);
    },

    isTouchDevice: function() {
        return this.isAndroidDevice() || this.isIphoneOrIpadDevice();
    },

    openSurvey: function (liveSessionId) {
        require(['survey/views/LiveClassSurveyPopup'], function (LiveClassSurveyPopup) {
            new LiveClassSurveyPopup({liveSessionId: liveSessionId});
        });
    },

    setupGoogleTagManager : function() {
        if (this.hasData('common') && this.getData('common').googleTagManagerId) {
            var googleTagManagerId = this.getData('common').googleTagManagerId;
            require(['common/scripts/GoogleTagManager'], function (GoogleTagManager) {
                jQuery('body').prepend(GoogleTagManager.getScript(googleTagManagerId));
            });
        }
    }

}



//////////////////
// WEBPACK FOOTER
// ./js/common/CommonConfig.js
// module id = 362
// module chunks = 24